import { UserRole } from "utils/Constants";

export const formattedUserRole = (roleName) => {
  if (roleName === UserRole.SUPERADMIN) return "Super Admin";
  return roleName.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
};
